exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#SQLQueryTextArea{font-size:20px}.CodeMirror{border:1px solid #eee;font-size:18px;line-height:18px;height:100%}", ""]);

// exports
